(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artsif-home-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const selector = '.artsif-home-reviews';
  const SPEED = 38;

  function init(section) {
    if (instances.has(section)) return;
    const rail = section.querySelector('[data-review-rail]');
    const marquee = section.querySelector('[data-review-marquee]');
    const group = section.querySelector('[data-review-group]');
    if (!rail || !marquee || !group || !group.children.length) return;

    const controller = new AbortController();
    const signal = controller.signal;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let clones = [];
    let frame = 0;
    let last = 0;
    let offset = 0;
    let groupWidth = 0;
    let paused = false;
    let visible = true;
    let dragging = false;
    let pointerId = null;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let resumeAt = 0;

    function cleanClone(node) {
      node.setAttribute('aria-hidden','true');
      node.removeAttribute('data-review-group');
      node.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      node.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
      node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => el.setAttribute('tabindex','-1'));
      return node;
    }

    function rebuildClones() {
      clones.forEach(node => node.remove());
      clones = [];
      groupWidth = group.getBoundingClientRect().width;
      if (!groupWidth) return;

      const viewportWidth = rail.getBoundingClientRect().width;
      const copiesNeeded = Math.max(2, Math.ceil((viewportWidth + groupWidth) / groupWidth));
      for (let i = 1; i < copiesNeeded; i += 1) {
        const clone = cleanClone(group.cloneNode(true));
        clones.push(clone);
        marquee.appendChild(clone);
      }

      offset = ((offset % groupWidth) + groupWidth) % groupWidth;
      marquee.style.transform = `translate3d(${-offset}px,0,0)`;
    }

    function measure() {
      section.style.setProperty('--artsif-review-viewport', document.documentElement.clientWidth + 'px');
      rebuildClones();
      last = 0;
    }

    function normalizeOffset(value) {
      if (!groupWidth) return value;
      return ((value % groupWidth) + groupWidth) % groupWidth;
    }

    function render() {
      marquee.style.transform = `translate3d(${-offset}px,0,0)`;
    }

    function tick(now) {
      if (!section.isConnected) { destroy(); return; }
      if (!last) last = now;
      const dt = Math.min(now - last, 40);
      last = now;

      if (!paused && !dragging && visible && !document.hidden && !reducedMotion.matches && now >= resumeAt && groupWidth > 0) {
        offset = normalizeOffset(offset + SPEED * dt / 1000);
        render();
      }
      frame = requestAnimationFrame(tick);
    }

    const observer = new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting ?? true;
      last = 0;
    }, { rootMargin:'150px 0px' });
    observer.observe(section);

    rail.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') paused = true; }, { signal });
    rail.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !dragging) { paused = false; last = 0; } }, { signal });

    marquee.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0) return;
      dragging = true;
      pointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartOffset = offset;
      paused = true;
      marquee.classList.add('is-dragging');
      marquee.setPointerCapture?.(pointerId);
    }, { signal });

    marquee.addEventListener('pointermove', event => {
      if (!dragging || event.pointerId !== pointerId) return;
      offset = normalizeOffset(dragStartOffset - (event.clientX - dragStartX));
      render();
    }, { signal });

    const endDrag = event => {
      if (!dragging || (event?.pointerId != null && event.pointerId !== pointerId)) return;
      dragging = false;
      if (pointerId != null && marquee.hasPointerCapture?.(pointerId)) marquee.releasePointerCapture(pointerId);
      pointerId = null;
      marquee.classList.remove('is-dragging');
      resumeAt = performance.now() + 900;
      paused = false;
      last = 0;
    };

    marquee.addEventListener('pointerup', endDrag, { signal });
    marquee.addEventListener('pointercancel', endDrag, { signal });
    marquee.addEventListener('lostpointercapture', endDrag, { signal });
    document.addEventListener('visibilitychange', () => { last = 0; }, { signal });
    window.addEventListener('resize', measure, { signal, passive:true });

    const ro = new ResizeObserver(measure);
    ro.observe(group);

    function destroy() {
      cancelAnimationFrame(frame);
      observer.disconnect();
      ro.disconnect();
      controller.abort();
      instances.delete(section);
    }

    measure();
    instances.set(section, destroy);
    frame = requestAnimationFrame(tick);
  }

  function scan(root) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll?.(selector).forEach(init);
  }
  scan(document);
  document.addEventListener('DOMContentLoaded', () => scan(document), { once:true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, section) => { if (event.target.contains(section)) destroy(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
